var GroupOrdersCalendarStrings = {
    title: function () { return 'Group Order'; },
    description: function () {
        return 'Start an order to feed a group for work. Employees can customize meals and get everything delivered together by highly rated Dashers.';
    },
    newOrderButton: function () { return 'New Order'; },
};
export default GroupOrdersCalendarStrings;
